export default __webpack_public_path__ + "static/media/walletconnect.d1c49a03.svg";